import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class QualityexecutionService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  addCheckListExecution(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/AddQualityCheckExecution', data);
  }
  addNewCheckListExecution(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/AddQualityNewCheckExecution', data);
  }


  editCheckListExecution(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/EditQualityCheckExecution', data);
  }

  getCheckListByIdForExecution(checkList: any): Observable<any[]> {
  return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/Qualitychecklistforexecution', checkList);
  //return this.http.post<any[]>(this.baseUrl + 'qualitychecklistforexecution', checkList);
  }


  getCheckList(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'qualitychecklists', data); 
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/GetCheckList', data);
  }

  CheckListShiftsByDate(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/Qualityexecutionshift', data);
  }

 

}
